import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  variant?: 'green' | 'terracota' | 'gold';
  onLinkClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  variant = 'green',
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full shadow-lg transition-all duration-300 transform hover:scale-105';
  const variantClasses = variant === 'green' ? 'bg-green hover:bg-green-light shadow-green/30 text-white' : variant === 'gold' ? 'bg-gold hover:bg-gold/90 shadow-gold/40 text-black' : 'bg-terracota hover:bg-terracota-light shadow-terracota/30 text-white';
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${variantClasses} ${className}`} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} data-id="element-50" data-mp="2vyypo2cg5dkg">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${variantClasses} ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} {...props} data-id="element-51" data-mp="895sn1q7ymkb">
      {children}
    </motion.button>;
}